import {Checkbox} from "@/components/ui/checkbox.tsx";
import {ReactNode} from "react";
import {cn} from "@/lib/utils.ts";
import Restricted from "@/components/permissions/Restricted.tsx";

type CheckboxProps = {
    checked: boolean,
    onCheckedChange: (checked: boolean) => void
}


export default function Theme({children, checkboxActions, imageActions, img, title, name}: {
    children?: ReactNode,
    checkboxActions: CheckboxProps,
    imageActions: CheckboxProps,
    img: string,
    title: string,
    name: string
}) {

    return (<Restricted to={name} enabled={name == "torzsgarda"}>
        <div className={"flex gap-4 items-center m-3"}>
            <div className={"flex items-center"}>
                <Checkbox {...checkboxActions}/>
            </div>
            <img onClick={() => imageActions.onCheckedChange(!imageActions.checked)}
                 className={cn("h-24 cursor pointer transition-all", imageActions.checked ? "ring-4 ring-primary" : "")}
                 src={img} alt={name}/>
            <div className={"flex h-full pt-2 flex-col gap-1"}>
                <p className={"font-bold"}>{title}</p>
                {
                    children
                }
            </div>
        </div>
    </Restricted>)

}